import { Maybe } from "@flockcover/flock-svc-core-types"

export const createUniqueRef = (
  registrationNumber: string,
  onCoverDate: string,
  offCoverDate?: Maybe<string>
): string => `VRN:${registrationNumber}-ON-COVER:${onCoverDate}-OFF-COVER:${offCoverDate ?? ``}`
